export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/imageupload.worker.5911177b.worker.js");
}
